import { type ChatItemLocationResults } from 'app/services/chatBot';

import BaseChatItem from '../BaseChatItem';
import LocationCard from './LocationCard';

const LocationResultsChatItem = ({ chatItem }: { chatItem: ChatItemLocationResults }) => {
  return (
    <BaseChatItem showAvatar={false}>
      <div className="flex flex-col gap-y-2">
        {chatItem.items.map((location) => (
          <LocationCard
            key={location.name}
            location={location}
          />
        ))}
      </div>
    </BaseChatItem>
  );
};

export default LocationResultsChatItem;
